export default "__VITE_ASSET__DxfOhWfO__"